import type { ReactNode } from 'react';
import { t } from '@app/i18n';
import { ErrorBanner, PageHeader } from '@zarya/ui';
import type { Role } from './sessionContext';
import { hasRole, useCurrentUser } from './useCurrentUser';

export interface RequireRoleProps {
  /** Papéis com acesso à rota. */
  papeis: readonly Role[];
  children: ReactNode;
  /** Título da página de recusa. */
  titulo?: string;
}

/**
 * Guard de papel por rota (FR-009, FR-010).
 *
 * O item correspondente já é omitido do menu (`navigation.ts`), mas a URL é
 * digitável: quem chega aqui sem o papel vê a recusa, com o mesmo código
 * (`sem_permissao`) que o servidor devolveria.
 *
 * Papel desconhecido (sessão em modo degradado) passa: a interface não recusa por
 * não saber quem é — o servidor recusa.
 */
export function RequireRole({ papeis, children, titulo }: RequireRoleProps) {
  const { papel } = useCurrentUser();

  if (hasRole(papel, papeis)) return <>{children}</>;

  return (
    <>
      {/* `titulo` continua opcional; o padrão saiu da assinatura para o corpo
          porque um valor padrão de parâmetro é avaliado a cada chamada, mas o
          texto tinha de sair do literal de qualquer forma. */}
      <PageHeader title={titulo ?? t('login.role.title')} icon="lock" />
      <ErrorBanner error="sem_permissao" title={t('login.role.message')} />
    </>
  );
}
